// extracted by mini-css-extract-plugin
module.exports = {"heading":"ExpandableList_heading__6pt88"};